import React from 'react';
import { Colgroup } from './colgroup';
import { getTableContainerWidth } from '@atlaskit/editor-common/node-width';
import { akEditorDefaultLayoutWidth } from '@atlaskit/editor-shared-styles';
export var Table = /*#__PURE__*/React.memo(function (_ref) {
  var _tableNode$attrs;
  var innerRef = _ref.innerRef,
    isNumberColumnEnabled = _ref.isNumberColumnEnabled,
    columnWidths = _ref.columnWidths,
    layout = _ref.layout,
    renderWidth = _ref.renderWidth,
    children = _ref.children,
    tableNode = _ref.tableNode,
    rendererAppearance = _ref.rendererAppearance,
    isInsideOfBlockNode = _ref.isInsideOfBlockNode,
    isinsideMultiBodiedExtension = _ref.isinsideMultiBodiedExtension,
    allowTableResizing = _ref.allowTableResizing;
  var tableWidth = tableNode ? getTableContainerWidth(tableNode) : akEditorDefaultLayoutWidth;
  if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) {
    tableWidth = 'inherit';
  }
  if (rendererAppearance === 'comment' && !allowTableResizing) {
    tableWidth = renderWidth;
  }
  var tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
  var tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
  return /*#__PURE__*/React.createElement("table", {
    "data-testid": "renderer-table",
    "data-number-column": isNumberColumnEnabled,
    "data-table-width": tableWidth,
    "data-layout": tableLayout,
    "data-table-display-mode": tableDisplayMode,
    ref: innerRef
  }, /*#__PURE__*/React.createElement(Colgroup, {
    columnWidths: columnWidths,
    layout: layout,
    isNumberColumnEnabled: isNumberColumnEnabled,
    renderWidth: renderWidth,
    tableNode: tableNode,
    rendererAppearance: rendererAppearance,
    isInsideOfBlockNode: isInsideOfBlockNode,
    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
    allowTableResizing: allowTableResizing
  }), /*#__PURE__*/React.createElement("tbody", null, children));
});